import * as React from 'react';
import { ReactElement } from 'react';
import { SearchProps } from './interfaces';

export function Search({ needle, setFilteredList, searchParam, style }: SearchProps): ReactElement {
    const handleSearch = (e: { target: HTMLInputElement }) => {
        const value = e.target.value;

        const needleCopy = [...needle];

        const newList = needleCopy.filter((seeked) => {
            return searchParam ? seeked[searchParam].toLowerCase().includes(value.toLowerCase()) : seeked.toLowerCase().includes(value.toLowerCase()) ;
        });

        newList.length !== 0 ? setFilteredList(newList) : setFilteredList(needle);
    };

    return <input placeholder="Rechercher" style={style} onChange={handleSearch} type="search" />
}